import React from 'react';
import { X } from 'lucide-react';

interface RejectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (reason: string) => void;
  userName: string;
  isSubmitting: boolean;
}

const RejectionModal: React.FC<RejectionModalProps> = ({ isOpen, onClose, onSubmit, userName, isSubmitting }) => {
  const [reason, setReason] = React.useState('');

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-slate-900/70 backdrop-blur-md z-[100] flex items-center justify-center p-4">
      <div className="bg-white rounded-[2rem] w-full max-w-md shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-200">
        <div className="p-6 bg-slate-50 border-b flex justify-between items-center">
          <h3 className="font-black text-slate-800 uppercase tracking-tight">Reject Application</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600"><X size={20} /></button>
        </div>
        <div className="p-8">
          <p className="text-sm text-gray-500 mb-4">Provide a reason for rejecting <b>{userName}</b>:</p>
          <textarea 
            className="w-full bg-gray-50 border-2 border-gray-100 rounded-2xl p-4 text-sm outline-none focus:border-blue-500 min-h-[140px] resize-none"
            placeholder="e.g. ID scan is blurry..."
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
          <div className="mt-8 flex gap-3">
            <button onClick={onClose} className="flex-1 py-3 text-sm font-bold text-gray-400">Cancel</button>
            <button 
              onClick={() => onSubmit(reason)}
              disabled={isSubmitting || !reason.trim()}
              className="flex-[2] bg-red-500 text-white rounded-2xl font-bold text-sm py-3 disabled:opacity-50"
            >
              {isSubmitting ? 'Sending...' : 'Confirm Rejection'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RejectionModal;